import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

const ProductCard = ({
  title,
  description,
  buttonText,
  productLink,
  productAction,
  comingSoon,
  imgSrc,
}) => {
  return (
    <div className="product-card">
      <div className="image-content">
        <img className="image" src={imgSrc} alt="product" />
      </div>
      <div className="content">
        <h5 className="title">{title}</h5>
        <p className="description">{description}</p>
        {productLink && (
          <a className="learn" href={productLink}>
            Learn more
          </a>
        )}
        {comingSoon ? (
          <a className="coming" href="mailto:support@datafarming.com.au">
            Contact Us
          </a>
        ) : (
          <a
            href={productAction}
            alt="product-button"
            className="product-button"
          >
            {buttonText}
          </a>
        )}
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  productAction: PropTypes.string.isRequired,
  productLink: PropTypes.string.isRequired,
  comingSoon: PropTypes.bool,
  imgSrc: PropTypes.string.isRequired,
};

ProductCard.defaultProps = {
  buttonText: "",
  comingSoon: false,
};

export default ProductCard;
